import { DetailSearchColumn } from './DetailSearchColumn';

export const SEARCH_COLUMNS = (onEye, arrayOrgan, accessAll) => [
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		formatter: DetailSearchColumn,
		formatExtraData: {
			onEye,
			arrayOrgan,
			accessAll,
		},
	},
	{
		dataField: 'numeroResolucion',
		text: 'Resolución',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'texto',
		text: 'Texto',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'comite',
		text: 'Órgano Colegiado',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'numeroSesion',
		text: 'Número de Sesión',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'dateSesion',
		text: 'Fecha de Sesión',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'dateLimit',
		text: 'Fecha de Cmpto.',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'areaResponsable',
		text: 'Área Responsable',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'areaAcompanante',
		text: 'Área Acompañamiento',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'nombreDocumentos',
		text: 'Documentos de Área',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		style: { maxWidth: '250px', whiteSpace: 'nowrap', textAlign: 'center' },
	},
];
